import { NodeType, PageNode } from "../../types/PageNode";

export const isHeaderNode = (node?: PageNode | null): boolean =>
  node?.type === NodeType.HeaderNode;

export const isNavigationRegionsNode = (node?: PageNode | null): boolean =>
  node?.type === NodeType.NavigationRegionsNode;

export const containsNavigationRegionsNode = (
  node?: PageNode | null,
): boolean => {
  if (!node) return false;
  if (isNavigationRegionsNode(node)) return true;
  return node.nodes?.some(containsNavigationRegionsNode) ?? false;
};

export const findNavigationRegionsNode = (
  node?: PageNode | null,
): PageNode | null => {
  if (!node) return null;
  if (isNavigationRegionsNode(node)) return node;

  for (const child of node.nodes ?? []) {
    const navigationRegion = findNavigationRegionsNode(child);
    if (navigationRegion) return navigationRegion;
  }

  return null;
};

export const isNodeInsideHeader = (
  pageRoot: PageNode | undefined,
  nodeId: string,
  insideHeader = false,
): boolean => {
  if (!pageRoot) return false;
  const nextInsideHeader = insideHeader || isHeaderNode(pageRoot);
  if (pageRoot.id === nodeId) return nextInsideHeader;

  return pageRoot.nodes?.some((child) =>
    isNodeInsideHeader(child, nodeId, nextInsideHeader),
  ) ?? false;
};

export const containsHeaderNode = (node?: PageNode | null): boolean => {
  if (!node) return false;
  if (isHeaderNode(node)) return true;
  return node.nodes?.some(containsHeaderNode) ?? false;
};

export const removeNavItemByUrl = (root: PageNode, urlToRemove: string): string[] => {
  const header = root.nodes?.find(isHeaderNode);
  if (!header) return [];

  const navRegion = findNavigationRegionsNode(header);
  if (!navRegion) return [];

  const removedIds: string[] = [];
  navRegion.nodes = (navRegion.nodes ?? []).filter((btn) => {
    if (btn.onClickAction?.value !== urlToRemove) return true;
    removedIds.push(btn.id);
    return false;
  });
  return removedIds;
};

export const removeNodesFromHtml = (html: string, nodeIds: string[]): string => {
  if (!html || !nodeIds.length) return html;

  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  nodeIds.forEach((id) => {
    doc.querySelectorAll(`[id="blockContent${id}"]`).forEach((element) => element.remove());
  });
  return doc.body.innerHTML;
};

export const canInsertNodeWithoutDuplicateHeader = (
  pageRoot: PageNode | undefined,
  nodeToInsert: PageNode,
): boolean =>
  !containsHeaderNode(nodeToInsert) || !containsHeaderNode(pageRoot);
